export default "__VITE_ASSET__c6d18dcc__"